import * as React from "react"
import PopupContext from "./PopoverContext"

const PopoverProvider = ({ children }: { children: React.ReactNode }) => {
  const { stack: initialStack } = React.useContext(PopupContext)
  const stack = React.useRef(initialStack.current)
  return (
    <PopupContext.Provider value={{ stack }}>{children}</PopupContext.Provider>
  )
}

export default PopoverProvider
